var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.get_class},[_vm._v(_vm._s(_vm.formatted_value))])
}
var staticRenderFns = []

export { render, staticRenderFns }